// Ownezzy support on WhatsApp. The number is set by a Super Admin (Settings -> Configuration -> Ownezzy contact) and
// comes with the branding (useOwnezzyContact in utils/branding.js); this one is used until it has loaded.
export const SUPPORT_WHATSAPP = "918893725078"; // +91 88937 25078

// Link that opens a WhatsApp chat with support, with the message already typed
export const supportLink = (message, whatsapp = SUPPORT_WHATSAPP) => `https://wa.me/${whatsapp || SUPPORT_WHATSAPP}?text=${encodeURIComponent(message)}`;

// Who is asking, so support can find the account without asking back
export const supportMessage = (user, topic = "I need help with my Ownezzy admin panel.") =>
    `Hi Ownezzy support, ${topic}${user ? ` (Login: ${user.username || user.email || user.phone})` : ""}`;

// Saving store settings fires this, so the setup checklist refreshes without a page reload
export const SETUP_CHANGED_EVENT = "ownezzy:setup-changed";

// Ownezzy's own site, where the Terms and Privacy Policy live (the marketing site runs on localhost:3000 locally)
const host = window.location.hostname;
const isLocal = host === "localhost" || host === "127.0.0.1" || host.endsWith(".localhost");
export const OWNEZZY_URL = isLocal ? "http://localhost:3000" : "https://ownezzy.com";
export const TERMS_URL = `${OWNEZZY_URL}/terms`;
export const PRIVACY_URL = `${OWNEZZY_URL}/privacy`;
export const PLANS_URL = `${OWNEZZY_URL}/#plans`;
